
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_5tvh0_99",
  "scrolling-background": "awsui_scrolling-background_hyvsj_5tvh0_102",
  "sticky-background": "awsui_sticky-background_hyvsj_5tvh0_108",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_5tvh0_116",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_5tvh0_129",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_5tvh0_139",
  "drawers-container": "awsui_drawers-container_hyvsj_5tvh0_151",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_5tvh0_162",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_5tvh0_185",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_5tvh0_190",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_5tvh0_231",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_5tvh0_241",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_5tvh0_245",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_5tvh0_259",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_5tvh0_245",
  "drawer": "awsui_drawer_hyvsj_5tvh0_151",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_5tvh0_290",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_5tvh0_299",
  "drawer-content": "awsui_drawer-content_hyvsj_5tvh0_290",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_5tvh0_307",
  "drawer-slider": "awsui_drawer-slider_hyvsj_5tvh0_310",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_5tvh0_317",
  "content": "awsui_content_hyvsj_5tvh0_343",
  "layout": "awsui_layout_hyvsj_5tvh0_364",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_5tvh0_437",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_5tvh0_452",
  "content-type-table": "awsui_content-type-table_hyvsj_5tvh0_466",
  "content-type-cards": "awsui_content-type-cards_hyvsj_5tvh0_466",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_5tvh0_472",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_5tvh0_475",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_5tvh0_489",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_5tvh0_492",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_5tvh0_502",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_5tvh0_505",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_5tvh0_508",
  "has-header": "awsui_has-header_hyvsj_5tvh0_508",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_5tvh0_523",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_5tvh0_523",
  "has-left-toggles-gutter": "awsui_has-left-toggles-gutter_hyvsj_5tvh0_546",
  "has-right-toggles-gutter": "awsui_has-right-toggles-gutter_hyvsj_5tvh0_549",
  "has-split-panel": "awsui_has-split-panel_hyvsj_5tvh0_569",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_5tvh0_569",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_5tvh0_577",
  "unfocusable": "awsui_unfocusable_hyvsj_5tvh0_582",
  "container": "awsui_container_hyvsj_5tvh0_592",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_5tvh0_618",
  "is-tools-open": "awsui_is-tools-open_hyvsj_5tvh0_621",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_5tvh0_621",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_5tvh0_621",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_5tvh0_621",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_5tvh0_630",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_5tvh0_647",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_5tvh0_651",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_5tvh0_655",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_5tvh0_659",
  "navigation-container": "awsui_navigation-container_hyvsj_5tvh0_668",
  "show-navigation": "awsui_show-navigation_hyvsj_5tvh0_706",
  "animating": "awsui_animating_hyvsj_5tvh0_729",
  "showButtons": "awsui_showButtons_hyvsj_5tvh0_1",
  "navigation": "awsui_navigation_hyvsj_5tvh0_668",
  "openNavigation": "awsui_openNavigation_hyvsj_5tvh0_1",
  "animated-content": "awsui_animated-content_hyvsj_5tvh0_791",
  "hide-navigation": "awsui_hide-navigation_hyvsj_5tvh0_800",
  "notifications": "awsui_notifications_hyvsj_5tvh0_810",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_5tvh0_816",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_5tvh0_833",
  "position-bottom": "awsui_position-bottom_hyvsj_5tvh0_880",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_5tvh0_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_5tvh0_909",
  "position-side": "awsui_position-side_hyvsj_5tvh0_922",
  "tools-container": "awsui_tools-container_hyvsj_5tvh0_944",
  "tools": "awsui_tools_hyvsj_5tvh0_944",
  "openTools": "awsui_openTools_hyvsj_5tvh0_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_5tvh0_1035",
  "hide-tools": "awsui_hide-tools_hyvsj_5tvh0_1045",
  "show-tools": "awsui_show-tools_hyvsj_5tvh0_1057",
  "has-tools-form": "awsui_has-tools-form_hyvsj_5tvh0_1035",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_5tvh0_1140",
  "trigger": "awsui_trigger_hyvsj_5tvh0_1140",
  "selected": "awsui_selected_hyvsj_5tvh0_1217",
  "badge": "awsui_badge_hyvsj_5tvh0_1237",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_5tvh0_1241",
  "dot": "awsui_dot_hyvsj_5tvh0_1252"
};
  